import { Component } from '@angular/core';
import { Label } from '../multi-section-form-preview.models';


@Component({
    selector: 'app-legend-information',
    templateUrl: './legend-information.component.html',
    styleUrls: ['./legend-information.component.css'],
    standalone: true,
    imports: [],
})
export class LegendInformationComponent {
  labels: Label[] = [
    {
      faIconClass: 'fa fa-check-circle text-success',
      infoText: 'Valid Response',
    },
    {
      faIconClass: 'fa fa-warning text-danger',
      infoText: 'Invalid Response',
    },
    {
      faIconClass: 'fa fa-ban text-disabled',
      infoText: 'Disabled/Non-editable Response',
    },
    {
      faIconClass: 'fa fa-exclamation-circle text-warning',
      infoText: 'Mandatory question to be answered',
    },
  ];
}
